import gql from "graphql-tag"
import fullTenantSettings from "./FullTenantSettings"

export default gql`
  fragment fullUnauthedTenant on UnauthedBusiness {
    uuid
    locale
    public_name
    settings {
      ...fullTenantSettings
    }
    subdomain
  }
  ${fullTenantSettings}
`
